import GreenMarker from '../../icons/GreenMarker'
import OrangeMarker from '../../icons/OrangeMarker'
import RedMarker from '../../icons/RedMarker'
import MajorWorksMarker from '../../icons/MajorWorksMarker'
import MarkerCluster from '../../icons/MarkerCluster'

const Legend = () => {
  return (
    <footer className="block md:flex bg-ocean text-white items-center justify-center p-4">
      <h4 className='h5 text-white px-8'>Map Legend:</h4>
      <div className="flex flex-wrap gap-4" role="figure">
        <div className="flex items-center gap-2" role="img" aria-labelledby="grouped_icon">
          <div className='w-12 h-12'>
            <MarkerCluster />
          </div>
          <p className="leading-none align-middle w-56" id="grouped_icon">Number of Grouped Outages</p>
        </div>
        <div className="flex items-center gap-2" role="img" aria-labelledby="red_icon">
          <div className='w-16 h-16'>
            <RedMarker />
          </div>
          <p className="leading-none align-middle w-56" id="red_icon">Current Water Outage</p>
        </div>
        <div className="flex items-center gap-2" role="img" aria-labelledby="green_icon">
          <div className='w-12 h-12'>
            <GreenMarker />
          </div>
          <p className="leading-none align-middle w-56" id="green_icon">Recently Completed Works</p>
        </div>
        <div className="flex items-center gap-2" role="img" aria-labelledby="orange_icon">
          <div className='w-12 h-12'>
            <OrangeMarker />
          </div>
          <p className="leading-none align-middle w-56" id="orange_icon">Upcoming Water Outage</p>
        </div>
        <div className="flex items-center gap-2" role="img" aria-labelledby="major_icon">
          <div className='w-12 h-12'>
            <MajorWorksMarker />
          </div>
          <p className="leading-none align-middle w-56" id="major_icon">Major Works</p>
        </div>
      </div>
    </footer>
  )
}

export default Legend
